export default __webpack_public_path__ + "static/Green_Gem-dfa15274fd6a68cf9bfc9c1ae2d3d541.png";